<mandates-banner></mandates-banner>
<mandates-approve-mandates-banner></mandates-approve-mandates-banner>
<router-outlet></router-outlet>
